import styles from "./BgSection.module.scss";

interface BgSectionProps {
  bgImage?: string;
  imageSize?: "small" | "medium" | "large";
  orientation?: "default" | "vertical" | "horizontal";
  children?: React.ReactNode;
  color?: "primary" | "secondary";
  position?: "left" | "right" | "top" | "middle";
}

const BgSection: React.FC<BgSectionProps> = ({
  children,
  bgImage,
  imageSize = "medium",
  position = "left",
  color = "transparent",
  orientation = "default",
}) => {
  return (
    <div className={`${styles[orientation]}`}>
      {bgImage && <img src={bgImage} className={`${styles[`${imageSize}-bgImage`]}`} alt="" />}
      <div className={`${styles.content} ${styles[color]} ${styles[position]}`}>
        {children}
      </div>
    </div>
  );
};

export default BgSection;
